export const EVENTS = {
  ORDERS: {
    LIST: 'orders.list',
    LOADING: 'orders.loading',
    LOADED: 'orders.loaded',
    LOAD_ERROR: 'orders.load_error',

    CREATE: 'orders.create',
    CREATING: 'orders.creating',
    CREATED: 'orders.created',
    CREATE_ERROR: 'orders.create_error',

    DETAIL: 'orders.detail',
    DETAIL_LOADING: 'orders.detail_loading',
    DETAIL_LOADED: 'orders.detail_loaded',
    DETAIL_ERROR: 'orders.detail_error',

    TRACK: 'orders.track',
    TRACKING: 'orders.tracking',
    TRACKED: 'orders.tracked',
    TRACK_ERROR: 'orders.track_error',

    CANCEL: 'orders.cancel',
    CANCELLING: 'orders.cancelling',
    CANCELLED: 'orders.cancelled',
    CANCEL_ERROR: 'orders.cancel_error',

    RATE: 'orders.rate',
    RATING: 'orders.rating',
    RATED: 'orders.rated',
    RATE_ERROR: 'orders.rate_error',
    REVIEW_REQUIRED: 'orders.review_required',

    STATS_UPDATED: 'orders.stats_updated',
    FETCH_STATS: 'orders.fetch_stats'
  },

  CHECKOUT: {
    INITIATE: 'checkout.initiate',
    INITIATING: 'checkout.initiating',
    INITIATED: 'checkout.initiated',
    INITIATE_ERROR: 'checkout.initiate_error',

    VALIDATE: 'checkout.validate',
    VALIDATING: 'checkout.validating',
    VALIDATED: 'checkout.validated',
    VALIDATE_ERROR: 'checkout.validate_error'
  }
};

export const ENDPOINTS = {
  ORDERS: {
    BASE: 'https://api.monrapidoo.com/order?group=ultraxeno',
    LIST: 'https://api.monrapidoo.com/order/list?group=ultraxeno',
    DETAIL: 'https://api.monrapidoo.com/order/details/{orderId}?group=ultraxeno',
    CREATE: 'https://api.monrapidoo.com/order/create?group=ultraxeno',
    UPDATE_STATUS: 'https://api.monrapidoo.com/order/update/status?group=ultraxeno',
    CANCEL: 'https://api.monrapidoo.com/order/cancel?group=ultraxeno',
    RATE: 'https://api.monrapidoo.com/order/submit/review?group=ultraxeno',
    USER_STATS: 'https://api.monrapidoo.com/order/user/stats?group=ultraxeno',
    RESTAURANT_STATS: 'https://api.monrapidoo.com/order/restaurant/stats?group=ultraxeno',
    PAYMENTS: 'https://api.monrapidoo.com/order/payments?group=ultraxeno',
    CALCULATE_FEES: 'https://api.monrapidoo.com/order/calculate-fees?group=ultraxeno'
  },

  RESTAURANTS: {
    DETAIL: '/api/restaurants'
  },

  CHECKOUT: {
    INITIATE: '/api/checkout/initiate',
    VALIDATE: '/api/checkout/validate'
  }
};
